import { useMutation, useQueryClient } from '@tanstack/react-query'

import type {
  BookingSessionResponse,
  InitiateSessionCheckoutRequest,
} from '../../types/booking-session.js'

import { apiClient } from '../../lib/client.js'
import { syncBookingSessionCache } from './cache.js'

export const useInitiateSessionCheckout = (sessionId: string) => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async (data: InitiateSessionCheckoutRequest) => {
      const response = await apiClient.client.post<BookingSessionResponse>(
        `/booking-session/${sessionId}/checkout`,
        data
      )
      return response.data
    },
    onSuccess: (data) => {
      syncBookingSessionCache(queryClient, data)
    },
  })
}
